import React from 'react';

import pogachaimage1 from "../../../../../assets/images/resource/food/pogacha1.jpg";

function RightSide() {
    return (

        <>
            <section className="menu-one alternate">
                {/* <div className="right-bg"><img src={bgone} alt="" title="" /></div> */}
                <div className="auto-container">
                    <div className="title-box centered">
                        {/* <div className="subtitle"><span>STARTER MENU</span></div> */}

                        <div className="pattern-image">
                            <img src={require('../../../../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                        </div>

                        <h2>Основни</h2>
                    </div>

                    <div className="row clearfix">
                        {/* <div className="image-col col-lg-7 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="image"><img src={menuone} alt="" /></div>
                            </div>
                        </div> */}
                        <div className="menu-col col-lg-5 col-md-12 col-sm-12">
                            <div className="inner">



                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Свински сач</h5></div><div className="price"><span>29.80 лв</span></div></div>


                                        <div className="text desc">свински врат, червена чушка, гъби, лук, домат</div>
                                        <div className="text desc">600 г</div>

                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Телешки Риб-Ай стек</h5>

                                            {/* <span className="s-info">SEASONAL</span> */}

                                        </div>
                                            <div className="price"><span>78.90 лв</span></div>

                                        </div>
                                        <div className="text desc">с гарнитура запечен сладък картоф с масло и крем фреш</div>
                                        <div className="text desc">450 г</div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="menu-one alternate">
                {/* <div className="right-bg"><img src={bgone} alt="" title="" /></div> */}
                <div className="auto-container">
                    <div className="title-box centered">
                        {/* <div className="subtitle"><span>STARTER MENU</span></div> */}

                        <div className="pattern-image">
                            <img src={require('../../../../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                        </div>

                        <h2>Супи</h2>
                    </div>

                    <div className="row clearfix">
                        {/* <div className="image-col col-lg-7 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="image"><img src={menuone} alt="" /></div>
                            </div>
                        </div> */}
                        <div className="menu-col col-lg-5 col-md-12 col-sm-12">
                            <div className="inner">



                                <div className="dish-block">
                                    <div className="inner-box">

                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Пилешка супа</h5></div><div className="price"><span>5.90 лв</span></div></div>


                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Рибена супа</h5>

                                            {/* <span className="s-info">SEASONAL</span> */}

                                        </div>
                                            <div className="price"><span>8.90 лв</span></div>

                                        </div>


                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="menu-one alternate">
                {/* <div className="right-bg"><img src={bgone} alt="" title="" /></div> */}
                <div className="auto-container">
                    <div className="title-box centered">
                        {/* <div className="subtitle"><span>STARTER MENU</span></div> */}

                        <div className="pattern-image">
                            <img src={require('../../../../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                        </div>

                        <h2>Десерти</h2>
                    </div>

                    <div className="row clearfix">
                        {/* <div className="image-col col-lg-7 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="image"><img src={menuone} alt="" /></div>
                            </div>
                        </div> */}
                        <div className="menu-col col-lg-5 col-md-12 col-sm-12">
                            <div className="inner">



                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Лимонов тарт</h5></div><div className="price"><span>8.90 лв</span></div></div>


                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Сезонен плод</h5></div><div className="price"><span>8.90 лв</span></div></div>


                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Тофи пудинг с тофи сос и сладолед</h5>

                                            {/* <span className="s-info">SEASONAL</span> */}

                                        </div>
                                            <div className="price"><span>10.90 лв</span></div>

                                        </div>


                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Панджиало</h5></div><div className="price"><span>10.90 лв</span></div></div>



                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>καρυδόπιτα</h5>
                                        
                                        </div><div className="price"><span>6.90 лв</span></div></div>

                                        <div className="text desc">орехова пита със сладолед</div>
                                        <div className="text desc">200 г</div>



                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Суфле с течен център</h5>
                                        
                                        </div><div className="price"><span>11.90 лв</span></div></div>



                                    </div>
                                </div>

                                

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="menu-one alternate">
                {/* <div className="right-bg"><img src={bgone} alt="" title="" /></div> */}
                <div className="auto-container">
                    <div className="title-box centered">
                        {/* <div className="subtitle"><span>STARTER MENU</span></div> */}

                        <div className="pattern-image">
                            <img src={require('../../../../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                        </div>

                        <h2>Разядки</h2>
                    </div>

                    <div className="row clearfix">
                        {/* <div className="image-col col-lg-7 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="image"><img src={menuone} alt="" /></div>
                            </div>
                        </div> */}
                        <div className="menu-col col-lg-5 col-md-12 col-sm-12">
                            <div className="inner">



                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Тирокафтери</h5></div><div className="price"><span>5.80 лв</span></div></div>

                                        <div className="text desc">пикантно сирене</div>


                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Тарама хайвер</h5>

                                            {/* <span className="s-info">SEASONAL</span> */}

                                        </div>
                                            <div className="price"><span>6.40 лв</span></div>

                                        </div>


                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Дзадзики</h5></div><div className="price"><span>5.60 лв</span></div></div>



                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Домашни люти чушки</h5></div><div className="price"><span>2.60 лв</span></div></div>



                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="menu-one alternate">
                {/* <div className="right-bg"><img src={bgone} alt="" title="" /></div> */}
                <div className="auto-container">
                    <div className="title-box centered">
                        {/* <div className="subtitle"><span>STARTER MENU</span></div> */}

                        <div className="pattern-image">
                            <img src={require('../../../../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                        </div>

                        <h2>Хляб</h2>
                    </div>

                    <div className="row clearfix">
                        {/* <div className="image-col col-lg-7 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="image"><img src={pogachaimage1} alt="" /></div>
                            </div>
                        </div> */}
                        <div className="menu-col col-lg-5 col-md-12 col-sm-12">
                            <div className="inner">



                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Домашен хляб</h5></div><div className="price"><span>0.80 лв</span></div></div>

                                        <div className="text desc">на филия</div>


                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Домашна питка погача</h5>

                                            {/* <span className="s-info">SEASONAL</span> */}

                                        </div>
                                            <div className="price"><span>1.50 лв</span></div>

                                        </div>


                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="menu-one alternate">
                {/* <div className="right-bg"><img src={bgone} alt="" title="" /></div> */}
                <div className="auto-container">
                    <div className="title-box centered">
                        {/* <div className="subtitle"><span>STARTER MENU</span></div> */}

                        <div className="pattern-image">
                            <img src={require('../../../../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                        </div>

                        <h2>Гарнитури</h2>
                    </div>

                    <div className="row clearfix">
                        {/* <div className="image-col col-lg-7 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="image"><img src={menuone} alt="" /></div>
                            </div>
                        </div> */}
                        <div className="menu-col col-lg-5 col-md-12 col-sm-12">
                            <div className="inner">



                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Пържени картофи</h5></div><div className="price"><span>4.90 лв</span></div></div>

                                        <div className="text desc">200 г</div>


                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Пържени картофи със сирене</h5>

                                            {/* <span className="s-info">SEASONAL</span> */}

                                        </div>
                                            <div className="price"><span>5.80 лв</span></div>

                                        </div>

                                        <div className="text desc">200 г</div>



                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Сладък пържен картоф</h5>

                                            {/* <span className="s-info">SEASONAL</span> */}

                                        </div>
                                            <div className="price"><span>6.90 лв</span></div>

                                        </div>

                                        <div className="text desc">200 г</div>



                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Салата коуслоу</h5>

                                            {/* <span className="s-info">SEASONAL</span> */}

                                        </div>
                                            <div className="price"><span>5.80 лв</span></div>

                                        </div>

                                        <div className="text desc">200 г</div>



                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Салата домати и краставици</h5>

                                            {/* <span className="s-info">SEASONAL</span> */}

                                        </div>
                                            <div className="price"><span>4.90 лв</span></div>

                                        </div>

                                        <div className="text desc">200 г</div>



                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="menu-one alternate">
                {/* <div className="right-bg"><img src={bgone} alt="" title="" /></div> */}
                <div className="auto-container">
                    <div className="title-box centered">
                        {/* <div className="subtitle"><span>STARTER MENU</span></div> */}

                        <div className="pattern-image">
                            <img src={require('../../../../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                        </div>

                        <h2>Добавки</h2>
                    </div>

                    <div className="row clearfix">
                        {/* <div className="image-col col-lg-7 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="image"><img src={menuone} alt="" /></div>
                            </div>
                        </div> */}
                        <div className="menu-col col-lg-5 col-md-12 col-sm-12">
                            <div className="inner">



                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Прошуто крудо</h5></div><div className="price"><span>2.00 лв</span></div></div>

                                        <div className="text desc">50 г</div>


                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Прошуто кото</h5>

                                            {/* <span className="s-info">SEASONAL</span> */}

                                        </div>
                                            <div className="price"><span>1.50 лв</span></div>

                                        </div>

                                        <div className="text desc">50 г</div>



                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Сос /всички видове/</h5>

                                            {/* <span className="s-info">SEASONAL</span> */}

                                        </div>
                                            <div className="price"><span>1.50 лв</span></div>

                                        </div>





                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Пеперони</h5>

                                            {/* <span className="s-info">SEASONAL</span> */}

                                        </div>
                                            <div className="price"><span>1.50 лв</span></div>

                                        </div>

                                        <div className="text desc">50 г</div>



                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Вентричина</h5>

                                            {/* <span className="s-info">SEASONAL</span> */}

                                        </div>
                                            <div className="price"><span>2.00 лв</span></div>

                                        </div>

                                        <div className="text desc">50 г</div>



                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Сирена</h5>

                                            {/* <span className="s-info">SEASONAL</span> */}

                                        </div>
                                            <div className="price"><span>2.00 лв</span></div>

                                        </div>

                                        <div className="text desc">50 г</div>



                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>

    )
}

export default RightSide;